module.exports={
  "Learn More" : "Más información",
  "CLOSED CAPTION PREVIEW": "VISTA PRELIMINAR DE SUBTÍTULOS",
  "Sample Text": "Texto de muestra",
  "Ad": "Anuncio",
  "Skip Ad": "Omitir anuncio",
  "LIVE": "EN VIVO",
  "GO LIVE": "TRANSMITIR EN VIVO",
  "CC Options": "Opciones de los subtítulos",
  "On": "Sí",
  "Off": "No",
  "Discovery": "Discovery",
  "Facebook Unavailable": "Facebook no está disponible.",
  "Facebook Success": "Mirar este video en Facebook",
  "Twitter Unavailable": "Twitter no está disponible.",
  "Twitter Success": "Mirar este video en Facebook",
  "Post Title": "Publicó el contenido correctamente.",
  "Account Configure": "Configure su cuenta en el dispositivo.",
  "Discover": "Descubrir",
  "Up next": "Siguiente",
  "Video Quality": "Calidad de video",
  "Share": "Compartir",
  "Start at": "Comenzar en",
  "Embed": "Insertar",
  "Email": "Correo electrónico",
  "Check out this video": "¡Encontré este video que puede interesarle! Mírelo: ",
  "To": "Para",
  "Subject": "Asunto",
  "Message": "Mensaje",
  "name@email.com": "nombre@correoelectrónico.com",
  "Optional Message": "Mensaje opcional",
  "Send": "Enviar",
  "RELOAD YOUR SCREEN OR TRY SELECTING A DIFFERENT VIDEO": "ACTUALICE LA PANTALLA O SELECCIONE UN VIDEO DIFERENTE.",
  "THIS IS NOT WORKING! :(": "ESTO NO FUNCIONA. :(",
  "NETWORK ERROR": "SE PRODUJO UN ERROR EN LA RED.",
  "Cannot Contact Server": "No se puede contactar al servidor.",
  "SAS ERROR": "SE PRODUJO UN ERROR EN SAS.",
  "Invalid Authorization Response": "La respuesta de autorización no es válida.",
  "SAS GEO ERROR": "SE PRODUJO UN ERROR EN LA UBICACIÓN DE SAS.",
  "This video is not authorized in your location": "Este video no está autorizado en su ubicación.",
  "SAS DOMAIN ERROR": "SE PRODUJO UN ERROR EN EL DOMINIO DE SAS.",
  "This video is not authorized for your domain": "Este video no está autorizado en su dominio.",
  "VIDEO NOT AVAILABLE YET": "EL VIDEO TODAVÍA NO ESTÁ DISPONIBLE.",
  "This video will be available soon": "El video estará disponible próximamente.",
  "VIDEO COMING SOON!": "¡PRÓXIMAMENTE UN VIDEO!",
  "This video is not available yet": "El video todavía no está disponible.",
  "You may need to refresh the page to access the video after it becomes available" : "Es posible que deba actualizar la página para acceder al video una vez que esté disponible.",
  "VIDEO NO LONGER AVAILABLE": "EL VIDEO YA NO ESTÁ DISPONIBLE.",
  "This video is no longer available": "El video ya no está disponible.",
  "SAS DEVICE ERROR": "SE PRODUJO UN ERROR EN EL DISPOSITIVO DE SAS.",
  "This video is not authorized for playback on this device": "La reproducción de este video no está autorizada en este dispositivo.",
  "SAS PROXY ERROR": "SE PRODUJO UN ERROR EN EL PROXY DE SAS.",
  "An anonymous proxy was detected. Please disable the proxy and retry.": "Se detectó un proxy anónimo. Deshabilite el proxy e inténtelo nuevamente.",
  "CONCURRENT STREAMS NUMBER EXCEEDED": "SE SUPERÓ LA CANTIDAD DE EMISIONES SIMULTÁNEAS.",
  "You have exceeded the maximum number of concurrent streams": "Superó la cantidad máxima de emisiones simultáneas.",
  "DEVICE BINDING ERROR": "SE PRODUJO UN ERROR EN EL ENLACE DE LOS DISPOSITIVOS.",
  "Device binding failed": "Se produjo un error en el enlace de dispositivos.",
  "DEVICE ID TOO LONG": "LA ID DEL DISPOSITIVO ES DEMASIADO LARGA.",
  "Device ID is too long": "La ID del dispositivo es demasiado larga.",
  "INVALID PLAYER TOKEN": "EL TOKEN DEL REPRODUCTOR NO ES VÁLIDO.",
  "Invalid Ooyala Player token": "El token del reproductor de Ooyala no es válido.",
  "AUTHORIZATION ERROR": "SE PRODUJO UN ERROR EN LA AUTORIZACIÓN.",
  "Unable to register this device to this account, as the maximum number of authorized devices has already been reached. Error Code 22": "No se pudo registrar este dispositivo en esta cuenta, dado que se alcanzó el número máximo de dispositivos autorizados. Código de error: 22",
  "Unable to access this content, as the maximum number of devices has already been authorized. Error Code 29": "No se pudo acceder a este contenido, dado que se alcanzó el número máximo de dispositivos autorizados. Código de error: 29",
  "Please remove one of your authorized devices to enable this device.": "Quite uno de los dispositivos autorizados para permitir este dispositivo.",
  "LICENSE ERROR": "SE PRODUJO UN ERROR EN LA LICENCIA.",
  "General error acquiring license": "Se produjo un error general al adquirir la licencia.",
  "DRM SERVER ERROR": "SE PRODUJO UN ERROR EN EL SERVIDOR DE DRM.",
  "DRM server error": "Se produjo un error en el servidor de DRM.",
  "INVALID ENTITLEMENTS ERROR": "SE PRODUJO UN ERROR CON ASIGNACIONES NO VÁLIDAS.",
  "User Entitlement Terminated - Stream No Longer Active for the User": "Finalizó la asignación del usuario. La emisión ya no estará activa para el usuario.",
  "INVALID HEARTBEAT": "LA PULSACIÓN NO ES VÁLIDA.",
  "Invalid heartbeat response": "La respuesta de pulsación no es válida.",
  "INVALID CONTENT": "EL CONTENIDO NO ES VÁLIDO.",
  "INVALID METADATA": "LOS METADATOS NO SON VÁLIDOS.",
  "Invalid Metadata": "Los metadatos no son válidos.",
  "PLAYBACK ERROR": "SE PRODUJO UN ERROR EN LA REPRODUCCIÓN.",
  "Could not play the content": "No se pudo reproducir el contenido.",
  "PLAYBACK STREAM ERROR": "SE PRODUJO UN ERROR EN LA EMISIÓN DE LA REPRODUCCIÓN.",
  "This video isn't encoded for your device": "Este video no está codificado para su dispositivo.",
  "PLAYBACK LIVESTREAM ERROR": "SE PRODUJO UN ERROR EN LA EMISIÓN EN VIVO DE LA REPRODUCCIÓN.",
  "Live stream is off air": "La emisión en vivo está desconectada.",
  "PLAYBACK NETWORK ERROR": "SE PRODUJO UN ERROR EN LA RED DE LA REPRODUCCIÓN.",
  "Network connection temporarily lost": "Se perdió temporalmente la conexión con la red.",
  "UNPLAYABLE CONTENT ERROR": "SE PRODUJO UN ERROR CON EL CONTENIDO, NO SE PUEDE REPRODUCIR.",
  "This video is not playable on this player": "Este video no se puede reproducir en este dispositivo.",
  "INVALID EXTERNAL ID": "LA ID EXTERNA NO ES VÁLIDA.",
  "Invalid External ID": "La ID externa no es válida.",
  "EMPTY CHANNEL ERROR": "SE PRODUJO UN ERROR, EL CANAL ESTÁ VACÍO.",
  "This channel is empty": "Este canal está vacío.",
  "EMPTY CHANNEL SET ERROR": "SE PRODUJO UN ERROR, EL CONJUNTO DE CANALES ESTÁ VACÍO.",
  "This channel set is empty": "Este conjunto de canales está vacío.",
  "CHANNEL CONTENT ERROR": "SE PRODUJO UN ERROR CON EL CONTENIDO DEL CANAL.",
  "This channel is not playable at this time": "Este canal no se puede reproducir en este momento.",
  "SOMETHING NOT RIGHT! THERE SHOULD BE VIDEOS HERE.": "¡SE PRODUJO UN ERROR! DEBERÍA HABER VIDEOS AQUÍ.",
  "(Try Clicking The Discover Button Again On Reload Your Page)": "(Intente hacer clic en el botón Descubrir de nuevo al cargar la página).",
  "Something happened while we were trying to play your video! Click replay or simply reload your page.": "Se produjo un error cuando intentamos reproducir tu video. Seleccione la opción para repetir el video o vuelva a cargar la página.",
  "Language": "Idioma",
  "Color Selection": "Selección de color",
  "Caption Opacity": "Opacidad de los subtítulos",
  "Font Type": "Tipo de fuente",
  "Font Size": "Tamaño de fuente",
  "Text Enhancements": "Mejoras en el texto",
  "Text color": "Color del texto",
  "Background color": "Color del fondo",
  "Window color": "Color de la ventana",
  "Transparent": "Transparente",
  "White": "Blanco",
  "Blue": "Azul",
  "Magenta": "Magenta",
  "Green": "Verde",
  "Yellow": "Amarillo",
  "Red": "Rojo",
  "Cyan": "Cian",
  "Black": "Negro",
  "Text opacity": "Opacidad del texto",
  "Background opacity": "Opacidad del fondo",
  "Window opacity": "Opacidad de la ventana",
  "Font size": "Tamaño de fuente",
  "Small": "Pequeña",
  "Medium": "Mediana",
  "Large": "Grande",
  "Extra Large": "Extra grande",
  "Text enhancement": "Mejora en el texto",
  "Uniform": "Uniforme",
  "Depressed": "Aplastada",
  "Raised": "Elevada",
  "Shadow": "Sombra",
  "Play": "Reproducir",
  "Replay": "Repetir video",
  "Pause": "Pausar",
  "Mute": "Silenciar",
  "Unmute": "Sonido",
  "Closed Captions":"Subtítulos",
  "Full Screen": "Pantalla completa",
  "Exit Full Screen": "Salir pantalla completa",
  "More Options": "Más Opciones",
  "Audio": "Audio",
  "Subtitles": "Subtítulos",
  "Undefined language": "Idioma no definido",
  "No linguistic content": "Sin contenido lingüístico",
  "Speed": "Velocidad",
  "Normal": "Normal"
}
